import { gql } from '@apollo/client';
import Fragments from './fragments';

export const SCORING_CATEGORY_QUERY = gql`
  query scoringCategory($scoringId: Int!) {
    scoringCategory(scoringId: $scoringId) {
      ...scoringCategoryItem
      scoringCategoryDetails {
        ...scoringCategoryDetailItem
      }
    }
  }
  ${Fragments.scoringCategoryItem}
  ${Fragments.scoringCategoryDetailItem}
`;

export const INPUT_TYPES_QUERY = gql`
  query inputTypes {
    inputTypes {
      id
      code
      name
      visibleYN
      orderNo
    }
  }
`;

export const SCALES_QUERY = gql`
  query scales {
    scales {
      id
      value
    }
  }
`;
